module.exports = __webpack_public_path__ + "img/mainMenu-iconOrder.a6412d66.svg";